import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AppEnvProvider"] */ "/app/src/context/AppEnv.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Provider"] */ "/app/src/hooks/useModel/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/hooks/useModel/models/auth-model.ts");
